import(/* webpackMode: "eager" */ "/Users/prathamesh/Downloads/claude-transfer/locobuzz-website/app/partnerships/page.js");
